import { getExperimentBranchFeatureKey, useGrowthbook } from '@experience/core-hostapp-share-lib';
import { onMounted } from 'vue';

/** Регистрирует опциональную ветку эксперимента через GrowthBook host-приложения. */
export const trackBranchExperiment = (experimentName: string | undefined): void => {
  if (!experimentName) {
    return;
  }

  onMounted(() => {
    const growthbook = useGrowthbook();

    growthbook?.isOn(getExperimentBranchFeatureKey(experimentName));
  });
};
